<template>
<v-container grid-list-md fluid >
  <v-layout row >
    <v-flex md4>
      <v-card>
        <v-toolbar dense primary-title class="py-0">
          <v-toolbar-title>{{$t('view.perfil.form.label')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
            <v-icon>{{ view.elem.showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
          </v-btn>
        </v-toolbar>
        <v-slide-y-transition>
          <div v-show="view.elem.showForm">
            <v-card-text>
              <v-layout row >
                <v-flex md12>
                  <v-form role="form">
                    <!-- Skeleton loader -->
                    <v-layout row class="form-group"
                      v-if="view.action.submit.busy">
                      <vue-content-loading :width="450" :height="158">
                        <rect x="0" y="0" rx="4" ry="4" width="53" height="10" />
                        <rect x="0" y="15" rx="4" ry="4" width="442" height="34" />
                        <rect x="0" y="64" rx="4" ry="4" width="53" height="10" />
                        <rect x="0" y="79" rx="4" ry="4" width="442" height="34" />
                        <rect x="0" y="128" rx="10" ry="10" width="80" height="30" />
                      </vue-content-loading>
                    </v-layout>
                    <v-text-field class="form-group"
                    v-if="!view.action.submit.busy"
                    v-show="view.elem.input.id.visible"
                    v-model="$v.perfil.id.$model"
                    :disabled="view.elem.input.id.disabled"
                    :error-messages="getFirstErrorDescription($v.perfil.id)"
                    :label="$t('view.perfil.id.label')" ></v-text-field>

                    <!-- <div v-show="view.elem.input.id.visible" class="form-group" 
                      v-if="!view.action.submit.busy" 
                      v-bind:class="[hasErrors($v.perfil.id)?'has-error':'']">
                      <label>{{$t('view.perfil.id.label')}}</label>
                      <input type="text" name="id" class="form-control"
                        v-model="$v.perfil.id.$model"
                        :disabled="view.elem.input.id.disabled">
                    </div> -->
                    <div v-if="!view.action.submit.busy"   v-bind:class="[hasErrors($v.perfil.groupName)?'has-error':'']">
                      <v-text-field 
                      v-model="$v.perfil.groupName.$model"
                      :error-messages="getFirstErrorDescription($v.perfil.groupName)"
                      :label="$t('view.perfil.groupName.label')" ></v-text-field>
                    </div>
                    <!-- <div class="form-group" 
                      v-if="!view.action.submit.busy" 
                      v-bind:class="[hasErrors($v.perfil.groupName)?'has-error':'']">
                      <label>{{$t('view.perfil.groupName.label')}}</label>
                      <input type="text" name="groupName" class="form-control"
                        :placeholder="$t('view.perfil.groupName.label')"
                        v-model="$v.perfil.groupName.$model">
                      <label class="error--text" for="groupName"
                        v-if="$v.perfil.groupName.$invalid && $v.perfil.groupName.$dirty">
                        {{getFirstErrorDescription($v.perfil.groupName)}} 
                      </label>
                    </div> -->
                    <div class="form-group" v-if="!view.action.submit.busy" >
                    <v-text-field 
                    v-model="$v.perfil.descripcion.$model"
                    :error-messages="getFirstErrorDescription($v.perfil.descripcion)"
                    :label="$t('view.perfil.descripcion.label')" ></v-text-field>
                    </div>
                    <!-- <div class="form-group" 
                      v-if="!view.action.submit.busy" 
                      v-bind:class="[hasErrors($v.perfil.descripcion)?'has-error':'']">
                      <label>{{$t('view.perfil.descripcion.label')}}</label>
                      <input type="text" name="descripcion" class="form-control"
                        :placeholder="$t('view.perfil.descripcion.label')"
                        v-model="$v.perfil.descripcion.$model">
                      <label class="error--text" for="descripcion"
                        v-if="$v.perfil.descripcion.$invalid && $v.perfil.descripcion.$dirty">
                        {{getFirstErrorDescription($v.perfil.descripcion)}} 
                      </label>
                    </div> -->
                    
                  </v-form>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-flex shrink>
                  <v-tooltip v-show="view.elem.button.audit.visible && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')" top>
                    <v-btn 
                      @click="showAudit()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>storage</v-icon>
                    </v-btn>
                    <span>{{$t('view.global.common.auditoria')}}</span>
                  </v-tooltip>
                  <v-tooltip v-show="view.elem.button.audit.visible && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')" top>
                    <v-btn 
                      @click="loadPrivileges($v.perfil.id.$model,$v.perfil.groupName.$model)" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>fa fa-lock</v-icon>
                    </v-btn>
                    <span>{{$t('view.global.common.privileges')}}</span>
                  </v-tooltip>
                  <v-tooltip v-show="view.elem.button.clear.visible" top>
                    <v-btn 
                      @click="askForClear()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>clear</v-icon>
                    </v-btn>
                    <span>{{$t('view.global.common.cancel')}}</span>
                  </v-tooltip>
                  <v-tooltip  v-show="$userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')" top>
                    <v-btn 
                      :disabled="state.isDisableButtonSubmit()" 
                      :loading="view.action.submit.busy" 
                      @click="submit()" 
                      color="primary"
                      icon slot="activator"  large>
                      <v-icon>check</v-icon>
                    </v-btn>
                    <span>{{submitTitle}}</span>
                  </v-tooltip>
              </v-flex>
            </v-card-actions>
          </div>
        </v-slide-y-transition>
      </v-card>
    </v-flex>
    <v-flex md8>
      <data-table ref="perfilTable" @editRow="loadPerfil"  @auditRow="showAudit" @showPrivileges="loadPrivileges"></data-table>
    </v-flex>
    <auditoria ref="auditModal" ></auditoria>
    <v-layout>
      <!-- Modal -->
      <div id="listRoleProfile" class="modal" tabindex="-1" role="dialog" aria-hidden="true"> 
        <div class="modal-dialog modal-lg">
          <div class="modal-content animated bounceInRight">
            <div class="modal-header">
              <button id="btnCloseModal" type="button"
                class="btn btn-outline btn-circle btn-lg btn-primary modal-close-sm modal-audit-close modal__close-button"
                data-dismiss="modal" style="width: 54px; height: 54px;">
                <i class="menu-item-icon button__icon icon fa fa-times"></i>
              </button>
              <h2 class="modal-title" style="padding-bottom:16px">{{view.elem.modal.rolePrivileges.privilegioTitle}}Privilegios Asignados</h2>
              <div class="row" style="padding-top:1em;">
                <div class="col-md-12" style="text-align:right;">
                  <label style="font-weight: normal;">Buscar:<input type="search" class="form-control input-sm modal__search-input" v-model="search" placeholder="" aria-controls="dataTableAudit"></label>
                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="height:300px; overflow-y: scroll;">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Privilegio</th>
                      <th class="text-xs-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in getPrivilegesFiltered">
                      <td>{{data.permiso}}</td>
                      <td class="text-xs-center" >
                        <v-tooltip  top  >
                          <v-btn 
                            :loading="data.busy" 
                            @click="privilegeAddOrRemove(data)"
                            :color="data.check ? 'primary' : 'green'"
                            fab
                            small
                            dark
                            slot="activator" >
                            <v-icon>{{data.check?'clear':'add'}}</v-icon>
                          </v-btn>
                          <span>{{data.check?'Quitar':'Agregar'}}</span>
                        </v-tooltip>
                        <!-- <button 
                          data-toggle="tooltip" 
                          data-placement="top"
                          v-if="!data.busy" 
                          :title="data.check?'Quitar':'Agregar'" 
                          class="privilege__action-button btn-action-edit button button--sacnite button--round-l "
                          :class="data.check? 'primary':'custom'"
                          @click="privilegeAddOrRemove(data)">
                          <i class="button__icon icon fa " :class="[data.check?'fa-times':'fa-plus']"></i>
                          <span>{{data.check?'Quitar':'Agregar'}}</span>
                        </button>
                        <div class="sk-spinner sk-spinner-circle"
                          v-if="data.busy">
                          <div class="sk-circle1 sk-circle"></div>
                          <div class="sk-circle2 sk-circle"></div>
                          <div class="sk-circle3 sk-circle"></div>
                          <div class="sk-circle4 sk-circle"></div>
                          <div class="sk-circle5 sk-circle"></div>
                          <div class="sk-circle6 sk-circle"></div>
                          <div class="sk-circle7 sk-circle"></div>
                          <div class="sk-circle8 sk-circle"></div>
                          <div class="sk-circle9 sk-circle"></div>
                          <div class="sk-circle10 sk-circle"></div>
                          <div class="sk-circle11 sk-circle"></div>
                          <div class="sk-circle12 sk-circle"></div>
                        </div> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-layout>
  </v-layout>
</v-container>
</template>
<script>
import {PerfilModel} from "@/models/seguridad/perfil";
import PerfilAPI from "@/services/seguridad/perfil";
import {required, maxLength} from "vuelidate/lib/validators";
import {allValidatorMethods} from "@/helpers/vuelidate";
import VueContentLoading from 'vue-content-loading';
import DataTable from "@/views/seguridad/perfil/DataTable";
import Auditoria from "@/components/auditoria/Auditoria";
import tippy from 'tippy.js';
import * as states from '@/views/seguridad/perfil/perfil-states';
import * as R from "ramda";
import {getErrors,getBusinessCode,getResponseDTO} from '@/helpers/http-response-handler';
import {isEmpty} from "@/helpers/validators";
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';
import Vue from 'vue';
import {scrollToForm} from '@/helpers/form-scroll-to';

//Element's Settings
const button = {
  submit:{
    enable:true
    , text:""
    , class:{
      current:""
      , save:"button__icon icon fa fa-plus"
      , update:"button__icon icon fa fa-check"
    }
    , data:{
       title:{
        current:"",
        save:"Guardar",
        update:"Actualizar"
       }
    }
  }
  , clear:{
    visible:false
  }
  , audit:{
    visible:false
  }
};
const modal = {
  rolePrivileges:{
    htmlElement:undefined
    , modal:undefined
    , privilegioTitle:""
  }
}
const input = {
  id :{
    disabled:true
    , visible: false
  }
}

//Action's state
const action = {
  submit:{
    busy:false
  }
  , privileges:{
    busy:false
  }
};

export default {
  name: "Perfil",
  head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  , data() {
    return {
      locale: this.$store.language
      , perfil : undefined
      , privileges:[]
      , state : new Object()
      , search:""
      , view:{
        title:"Perfiles"
        , action
        , elem:{
          button
          , modal
          , input
          , showForm:true
        }
      }
    };
  }
  ,methods: {
    ...allValidatorMethods
    , getErrorsPerfil(defaultMessage, message, code){
      return getErrors('Perfil',defaultMessage, message, code);
    }
    , getBusinessCodePerfil(response){
      return getBusinessCode(response);
    }
    , getResponseDTOPerfil(response){
      return getResponseDTO(response);
    }
    , handleResponse(response){
      const code = this.getBusinessCodePerfil(response);
      if(code == 'OK')
      {
        EventBus.$emit(events.MESSAGES, {type:code});
        return true;
      }
      else 
      {
        if(response != false)
           EventBus.$emit(events.MESSAGES, {type:'error',message: this.getErrorsPerfil('Mensaje Default',code)});
        return false;
      }
    }
    , async submit(){
      try
      {
        const respuesta = await this.state.submit(this.perfil);
        const responseDTO = this.getResponseDTOPerfil(respuesta);
        this.handleResponse(respuesta);
        Object.setPrototypeOf(this.state, new states.EditingState(this, responseDTO.grupo));    
      }catch(error){
        console.log(error)
      }
      
    }
    , initialState(){
      Object.setPrototypeOf(this.state, new states.InitialState(this));
    }
    , async loadPerfil(id){
      try{
        const response = await PerfilAPI.get({id});
        const {data:{results:{grupo}}} = response;
        Object.setPrototypeOf(this.state, new states.EditingState(this,grupo));
        scrollToForm(this); 
      }catch(error){
        console.log(error)
      }
    }
    , async privilegeAddOrRemove(privilegio){
      if(this.$userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD'))
      {
        try{
          let response;
          privilegio.busy=true;
          if(privilegio.check){
            response = await PerfilAPI.removePrivilege(privilegio);
          }else{
            response = await PerfilAPI.addPrivilege(privilegio);
          }
          if(response.status==200 &&  response.data.meta.code && response.data.meta.code=="OK")
            privilegio.check = !privilegio.check;
          
          setTimeout(()=>{privilegio.busy=false},200);
        }catch(error){
          privilegio.busy=false;
          console.log(error)
        }
      }
      else
      {
        EventBus.$emit(events.MESSAGES, {type:'error',message: "No tiene permiso para realizar la acción"});
      }
    }
    , askForClear(){
      this.state.askForClear();
    }
    , async showAudit(id=this.perfil.id, dataDescripcion=this.perfil.descripcion){
        this.$refs.auditModal.loadAudit({clave:id,tabla:'Groups',descripcion:dataDescripcion,revision:null});
    }
    , async loadPrivileges(id,nombrePerfil){
      try{
        const respuesta = await PerfilAPI.getPrivileges({id})
        const {data:{results:{permisosPerfil:data}}}= respuesta;
        this.privileges = data;
        this.privileges.forEach(item=>{this.$set(item, 'busy', false)});
        this.view.elem.modal.rolePrivileges.privilegioTitle = `Perfil: ${nombrePerfil} - ` || ''
        this.view.elem.modal.rolePrivileges.modal.show();
      }catch(error){
        console.log(error)
      }
    }
    , createRolePrivilegesModal(){
      this.view.elem.modal.rolePrivileges.htmlElement=document.getElementById('listRoleProfile');
      this.view.elem.modal.rolePrivileges.modal = new Modal(
        this.view.elem.modal.rolePrivileges.htmlElement
        ,{
          keyboard:true
          , backdrop:'static'
        }
      );
    }
  }
  , computed:{
    submitClass(){
      return this.view.elem.button.submit.class.current
    },
    submitTitle(){
      
      return this.view.elem.button.submit.data.title.current
    }
    , getPrivilegesFiltered(){
      if(isEmpty(this.search)){
        return this.privileges
      }else{
        return this.privileges.filter(privilege=>privilege.permiso.toLowerCase().includes(this.search.toLowerCase()))
      }
    }
  }
  , validations:{
    perfil:{
      id:{
        required:false
      }
      , groupName:{
        required
        , maxLength : maxLength(50)
      }
      , descripcion:{
        required
        , maxLength : maxLength(250)
      }
    }
    /*estatus:{
      required
    }*/
  }
  , components: {
    VueContentLoading
    , DataTable
    , Auditoria
  }
  // Instance Lifecycle Hooks
  , created(){
    Object.setPrototypeOf(this.state, new states.InitialState(this));
  }
  , mounted(){
    this.createRolePrivilegesModal();
  },
  updated(){
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal__search-input{
  margin-left: 0.5em;
  display: inline-block;
  width: auto;
  vertical-align: middle;
}
.modal__header{
  height: 50px;
}
.modal__close-button{
  position: absolute;
  right: 0;
  margin-right: 15px;
  width: 54px; 
  height: 54px; 
  border-radius: 27px;
}
.privilege__action-button{
  display:block;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/seguridad/perfil/Perfil.vue